import { EnviromentConfig } from './environment-keys';

export const environment: EnviromentConfig = {
  production: false,
  configSource: process.env['NG_APP_BWM_JSON_CONFIG'] || './assets/config/default.json',
};

